import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { PRIORITY_TASK_QUERY } from '../graphql/queries'
import { FETCH_PRIORITY_TASK } from '../redux/action-types'
import { cleanupFetchPriorityTask } from '../redux/actions'

const usePriorityTaskQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchPriorityTask)

  const { isLoading, error, data } = useSelector(
    store => store.priorityTasks.priorityTask,
  )

  const refetch = useCallback(
    id =>
      apolloService.query({
        query: PRIORITY_TASK_QUERY,
        variables: {
          id,
        },
        dispatch,
        action: FETCH_PRIORITY_TASK,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading, error, data }
}

export default usePriorityTaskQuery
